const Advert = require('./advert');
class Advert_One extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
    this.categoryIdNew = $('#categoryIdNew').val();
  }

  SetDOM() {
    if (this.admData.gameId) {
      this._gameId = this.admData.gameId;
    } else {
      this._gameId = $('#_gameId').val() > 0 ? $('#_gameId').val() : 0;
    }
    const exposestat = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'other',
      ag_a4: 1,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    const exposestat1 = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'btn',
      ag_a4: 1,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    this.DOM = $(`<div><div ${this.IsInPc() ? '' : 'type="xlyx-count-item"'} data-game-id="${this.admData.gameId}" data-game-name="${this.gameBaseInfo.gameName}" class="m-ad-1 stat-recsys-show" ${exposestat}>
  <div class="m-ad-1-container">
    <div class="m-ad-1-title">${this.ex.mainTitle || ''}</div>
    <div class="m-ad-1-content">
      <div class="m-ad-1-content-img stat-recsys-down">
        <img src="${this.ex.logoImageUrl || ''}" />
      </div>
      <div class="m-ad-1-content-detail" ${exposestat1}>
        <div class="m-ad-1-content-detail-title">${this.ex.subTitle || ''}</div>
        <a class="${this.IsInPc() ? '' : 'game-recommend-download'} m-ad-1-content-detail-title-button f-button ${this.ex.fButtonQdown === '0' ? 'stat-recsys-down' : 'stat-recsys-app-down'}">
          ${this.ex.fButtonText || ''}
          <div class="btn-qrcode-box">
            <div class="tip">扫一扫，立即获取</div>
            <div class="qrcode"></div>
          </div>
        </a>
        <a  class="${this.IsInPc() ? '' : 'game-recommend-download'} m-ad-1-content-detail-title-button s-button ${this.ex.sButtonQdown === '0' ? 'stat-recsys-down' : 'stat-recsys-app-down'}">
          ${this.ex.sButtonText || ''}
          <div class="btn-qrcode-box">
            <div class="tip">扫一扫，立即获取</div>
            <div class="qrcode"></div>
          </div>
        </a>
        ${this.ex.fButtonQdown !== '0' || this.ex.sButtonQdown !== '0' ? '<p class="m-ad-1-content-detail-alert">需优先下载九游APP</p>' : ''}
      </div>
    </div>
  </div>
</div><!--*{游戏推荐 下了又下模块}*-->${this.renderXlyx()}</div>`);
    this.InitEvent();
  }

  InitEvent() {
    this.InitButtonEvent();
  }

  InitButtonEvent() {
    // this.DOM.find('.m-ad-1-content-img').on('click', e => {
    //   if (!this.gameBaseInfo.downUrl) return;
    //   window.location = this.gameBaseInfo.downUrl;
    // });
    console.log(this.DOM.find('.m-ad-1-content-detail-title-button.s-button'))
    console.log(this.DOM.find('.m-ad-1-content-detail-title-button.f-button,.m-ad-1-content-img'))
    this.DOM.find('.m-ad-1-content-detail-title-button.s-button').on('click', e => {
      const agStatData = {
        ag_extend: 'advert',
        ag_a1: this.getAGA1(this.data.adpId),
        ag_a2: 'btn',
        ag_a3: 2,
        ag_a4: 1,
        ag_a5: this.admData.admId,
        ag_a7: this.data.odPlanId,
        ag_a8: this.data.adPutType || '',
        ag_a9: this.categoryIdNew,
      };
      this.ag_stat.customStatPortal(agStatData, 'quick_down');
      const ch = this.ex.qdownCh || 'OK_2431';
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, ch, this.gameBaseInfo.packageproperty);
      // if (this.ex.sButtonQdown === '0' && this.gameBaseInfo.downUrl) {
      //   window.location = this.gameBaseInfo.downUrl + `?ch=${this.ex.downCh}`;
      // } else {
      //   this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      // }
    });

    this.DOM.find('.m-ad-1-content-detail-title-button.f-button,.m-ad-1-content-img').on('click', e => {
      const agStatData = {
        ag_extend: 'advert',
        ag_a1: this.getAGA1(this.data.adpId),
        ag_a2: 'btn',
        ag_a3: 1,
        ag_a4: 1,
        ag_a5: this.admData.admId,
        ag_a7: this.data.odPlanId,
        ag_a8: this.data.adPutType || '',
        ag_a9: this.categoryIdNew,
      };
      this.ag_stat.customStatPortal(agStatData, 'quick_down');
      const ch = this.ex.qdownCh || 'OK_2431';
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, ch, this.gameBaseInfo.packageproperty);
      // if (this.ex.fButtonQdown === '0' && this.gameBaseInfo.downUrl) {
      //   window.location = this.gameBaseInfo.downUrl + `?ch=${this.ex.downCh}`;
      // } else {
      //   this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      // }
    });

    if (this.IsInPc() && window.xMan_qrcode) {
      this.DOM.find('.qrcode').each((idx, elem) => {
        let key = 'fButtonQdown';
        if ($(elem).hasClass('s-button')) {
          key = 'sButtonQdown';
        }
        let ch = 'OK_2003';
        if (window.location.pathname.indexOf('news') > -1) {
          ch = 'OK_2011';
        }
        const downUrl = 'https://web.9game.cn/share?pageType=game_detail&ch=' + ch + '&gameId=' + this._gameId + '&pullUpFrom=ugt_game_highspeed_' + this._gameId + '&opt=download';
        // if (this.ex[key] && this.ex[key] === '0' && this.gameBaseInfo.downUrl) {
        //   downUrl = this.gameBaseInfo.downUrl + `?ch=${this.ex.downCh}`;
        // }
        const qrcode = window.xMan_qrcode({
          render: 'canvas',
          width: 140,
          height: 140,
          correctLevel: 0,
          text: downUrl,
        });
        $(elem).append(qrcode);
      });
    }
  }
}

module.exports = Advert_One;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_one.js